import { ApiType } from "@gymflow/common";
import { SessionPackDTO } from "@gymflow/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { sessionPackQueryKeys } from "./sessionPackQueryKeys";

export function useSessionPack(
  {
    api,
    sessionPackId,
  }: {
    api: ApiType;
    sessionPackId?: number;
  },
  opts?: Omit<UseQueryOptions<SessionPackDTO | null>, "queryKey">,
) {
  return useQuery({
    queryKey: sessionPackQueryKeys.details(sessionPackId),
    queryFn: async () => {
      return (await api.creditPackApi.findById(sessionPackId!)).data;
    },
    enabled: !!sessionPackId,
    ...opts,
  });
}
